import { generateClasses } from '@formkit/themes'
import { check, circle, down } from '@formkit/icons'
import { defineFormKitConfig } from '@formkit/vue'
import formkitTheme from './formkit-theme.js'

export default defineFormKitConfig(() => {
  return {
    icons: {
      checkboxDecorator: check,
      radioDecorator: circle,
      select: down,
    },
    config: {
      classes: generateClasses(formkitTheme),
      // anything that's in this config prop you can pass as a config prop to the components..
    },
  }
})
